module.exports = __webpack_public_path__ + "img/contact_list.427be33f.png";